// extracted by mini-css-extract-plugin
module.exports = {"higpp-l-login-box-loading-provider":"LoadingProvider_higpp-l-login-box-loading-provider__1Preu","higpp-l-icon-wrapper":"LoadingProvider_higpp-l-icon-wrapper__Z26hZ"};